import templateUrl from './resourceActionTest.html'

/**
 * Resource action: Test Epc Reader component.
 *
 * Not used directly, but dynamically generated by {@link tmrResourceActions} directive.
 *
 * @example
 * <tmr-resource-action-test
 *   resource="$ctrl.resource"
 * ></tmr-resource-action-test>
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 */
export const tmrResourceActionTest = {
  ngType: 'component',
  templateUrl,
  bindings: {
    resource: '<',
  },
}
